import { INameList } from "../../service/synchronyme/INameList.interface";
import { commonApiLabels } from "libraries/const/commonApiLabels";

import _unset from 'lodash-es/unset';
import _keys from 'lodash-es/keys';
import _find from 'lodash-es/find';
import _forEach from 'lodash-es/forEach';
import _toString from 'lodash-es/toString';
import _set from 'lodash-es/set';
import _values from 'lodash-es/values';
import _pullAt from 'lodash-es/pullAt';
import _findIndex from 'lodash-es/findIndex';
import _isObject from 'lodash-es/isObject';

import { faPlus, faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons";

import { Yii } from "libraries/interfaces/Yii";
declare var wenji: any;

// Core modules
import { Component, EventEmitter } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import {forkJoin, Subscription} from 'rxjs';

//Services
import { TnrService } from "../../service/tnr/tnr.service";
import { PnrService } from "../../service/pnr/pnr.service";
import { SynchronymeService } from "../../service/synchronyme/synchronyme.service";
import { AuthService } from 'libraries/service/auth/auth.service';
import { SelectService } from 'libraries/service/select/select.service';
import { GroupResourceService } from "libraries/service/resources/group/groupResource.service";
import { ILabels } from "libraries/interfaces/ILabels";
import {PermissionResourceService} from "../../../libraries/service/resources/permission/permissionResource.service";

@Component({
    selector: 'tnr-list',
    templateUrl: 'tnrlist.component.html',
    styleUrls: ['tnrlist.component.scss'],
})
export class TnrListComponent {

    /// VARS ///
    public nameListsConfig: INameList[];

    public apiLabels: ILabels = commonApiLabels;

    public labels: ILabels = {};

    public s_tnrData: any;
    public s_pnrData: any;
    public s_listData: any;

    public focusInput: EventEmitter<boolean> = new EventEmitter<boolean>();
    public appData: any;
    public listData: any;
    public Yii = Yii;
    public inputTnr: string;

    //flag vars
    public f_showForm: boolean = false;
    public canAddReferencePermission: boolean = false;

    public iconTimes: IconDefinition = faTimes;

    public iconPlus: IconDefinition = faPlus;


    /**
     * getDummyTnrList
     *
     * get dummy data if typed in url. Launched at startUp if midOfficeRef is set on url
     *
     * @param {string} _id : jsonblob id or json file name (no extension)
     *                       default : this.urlParams.midOfficeRef (from url)
     */
    public tnrPending: boolean = false;
    public tnrError: boolean = false;
    public tnrErrorMessage: string;
    public tnrList: any[] = [];
    public wording: any = {};
    public routeParams: any = {};
    public f_alreadyAddedMessage: boolean = false;
    private urlParams: any = {};

    /**
     * @type {Subscription}
     * @private subscription
     */
    private subscription: Subscription;
    private subscription2: Subscription;
    private subscription3: Subscription;
    private subscription4: Subscription;
    private subscriptionPending: Subscription;


    ///LIFECYCLE ///
    constructor(
        private tnrService: TnrService,
        private pnrService: PnrService,
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private synchronyme: SynchronymeService,
        private select: SelectService,
        private groupResource: GroupResourceService,
        private readonly permissionResourceService: PermissionResourceService
    ) {
        this.s_listData = select.data;
        this.appData = this.synchronyme.data;
    }

    public ngOnInit(): void {

        this.permissionResourceService.hasPermission("skn.booking.reference.add").subscribe(
            (result: boolean): boolean => this.canAddReferencePermission = result);

        this.synchronyme.getNamelists()
            .subscribe((nameLists) => {
                this.nameListsConfig = nameLists;
            });

        this.wording = wenji.synchronyme.wording;

        if (this.appData.urlParams.midOfficeRef) {
            this.authService.isExpiredTokenThen().subscribe(() => {
                this.getTnrList(this.appData.urlParams.midOfficeRef, this.appData.urlParams.midOfficeRefType);
            });
        }


        this.subscription2 = this.tnrService.showTnrEvent
            .subscribe(
                (_id: string) => {
                    this.getTnrList(_id);
                }
            );


        this.subscription3 = this.tnrService.addedPaxEvent
            .subscribe(
                (_data: any) => {
                    let reference: string;
                    if (_data.reference) {
                        reference = _data.reference;
                        _unset(_data, 'reference');
                    }
                    if (!reference) {
                        reference = 'id';
                    }

                    const key = _keys(_data)[0];
                    const tnrToUpdate = _find(this.tnrList, (o: any) => {
                        return this.getBookingId(o) === key;
                    });
                    _forEach(_data[key], (v: any, k: string) => {
                        const paxToUpdate = _find(tnrToUpdate.traveller, (pax: any) => {
                            return _toString(pax[reference]) === _toString(k);
                        });
                        _set(paxToUpdate, 'journey.booking', v);
                        _set(paxToUpdate, 'journey.id', v.id);

                    });
                },
                (error: Error) => console.error(error)
            );
        this.subscription4 = this.tnrService.removedPaxEvent
            .subscribe(
                (_data: any) => {
                    const tnrId = _data.tnrId;
                    const paxId = _data.paxId;
                    const tnrToUpdate = _find(this.tnrList, (o: any) => {
                        return this.getBookingId(o) === tnrId;
                    });
                    const paxToUpdate = _find(tnrToUpdate.traveller, (pax: any) => {
                        return _toString(pax.id) === _toString(paxId);
                    });
                    _unset(paxToUpdate, 'journey');
                },
                (error: Error) => console.error(error)
            );

    }

    public ngOnDestroy(): void {

        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.subscription2) {
            this.subscription2.unsubscribe();
        }
        if (this.subscription3) {
            this.subscription3.unsubscribe();
        }
        if (this.subscription4) {
            this.subscription4.unsubscribe();
        }
        if (this.subscriptionPending) {
            this.subscriptionPending.unsubscribe();
        }
    }


    ///METHODS ///

    /**
     * add Tnr List
     * add a TNR to the list, launched from response observable
     * @param {any} _data: Tnr object to add
     */
    public addTnrList(_data: any): void {
        const idToAdd = this.getBookingId(_data);
        this.tnrList.push(_values(_data)[0]);
        this.handleExistingPnr(_values(_data)[0]);

        this.f_showForm = false;
        this.synchronyme.addOnTnrList(idToAdd, _values(_data)[0]);
        this.synchronyme.setTnrNb(this.tnrList.length);

        // Getting journey from first tnr (https://projets2.afidium.com/issues/29685)
        if(this.tnrList.length === 1 && this.tnrList[0].journey?.id && (this.tnrList[0].journey?.ids === null || !this.tnrList[0].journey?.ids.length)){
            this.groupResource.getNameList(this.tnrList[0].journey?.id.toString())
                .subscribe((data) => {
                    this.synchronyme.setBookingJourney(data);
                });
        }

        if(this.tnrList.length === 1 && this.tnrList[0].journey?.ids !== null){
            forkJoin(
                ...this.tnrList[0].journey?.ids.map((journeyId) => this.groupResource.getNameList(journeyId))
            ).subscribe((data: any[]): void => {
                const result: any[] = data.flat().filter(dataItem => Object.values(dataItem.journey.booking).filter((booking: any): boolean => booking.type === "NAMELIST").length || !dataItem.traveller.length);
                const formattedData = this.synchronyme.setFutureNameLists(result);
                this.pnrService.showFutureNamelist(formattedData);
            });
        }
    }

    /**
     * remove Tnr List
     * remove a TNR of the list
     */
    public removeTnrList(_index: number): void {
        //delete from rendering
        this.synchronyme.removeFromTnrList(this.getBookingId(this.tnrList[_index]));
        _pullAt(this.tnrList, [_index]);
        // set list number to stock/renew routing
        this.synchronyme.setTnrNb(this.tnrList.length);
    }


    /**
     * show Group when click on association
     */
    public showPnr(_event: any): void {
        const event = JSON.parse(_event);
        if (event.type === "PNR") {
            this.pnrService.showPnr(event.id);
        }
        if (event.type === "NAMELIST") {
            this.pnrService.showNamelist(event.id);
        }
    }

    /**
     * isDisplayedList
     *
     * @param {string} _id : id of the tnr list to be tested
     *
     */
    public isDisplayedTnrList(_id: string): boolean {
        // let output: boolean= true;
        const index = _findIndex(this.tnrList, (_val: any) => {
            return this.getBookingId(_val) === _id;
        });

        return index > -1;
    }

    /**
     * getBookingId
     *
     * get the bookinId from a TNR object
     *
     * @param {any} _tnr : _tnr object
     * @returns {string} : booking Id
     *
     */
    public getBookingId(_tnr: any): string {

        let bookingId: string = '';
        if (_keys(_tnr).length === 1) {
            bookingId = _values(_values(_tnr)[0].booking.code)[0];
        } else {
            if (_isObject(_tnr.booking.code)) {
                bookingId = _values(_tnr.booking.code)[0];
            } else {
                bookingId = _tnr.booking.code;
            }
        }
        return bookingId;

    }

    public getTnrList(_id: string, _type: string = null): void {
        if (this.synchronyme.isTnrOnList(_id, _type)) {
            this.setTnrError(Yii.t('wui-skn-js', 'Le Dossier est déjà affiché.'));
        } else {
            this.tnrPending = true;
            this.groupResource.getTnr(_id, _type)
                .subscribe(
                    (data: any) => {
                        if (this.synchronyme.hasSameJourney(data)) {
                            this.tnrPending = false;
                            this.addTnrList(data);
                        } else {
                            this.setTnrError(Yii.t('wui-skn-js', 'Trajet différent'));
                        }
                    },
                    (error: Error) => {
                        this.setTnrError(error.message);
                    }
                );
        }

    }

    private handleExistingPnr(_tnr: any){
        let loadedPnrIds = [];

        _forEach(_tnr.traveller, (traveller: any, k: string) => {
            if (traveller.journey){
                if (traveller.journey.booking && traveller.journey.booking.type){
                    const type = traveller.journey.booking.type;
                    const event = {
                        type: type,
                        id: "",
                        host: "",
                    };

                    if(type === "PNR"){
                        if (_isObject(traveller.journey.booking.code)) {
                            event.id = _values(traveller.journey.booking.code)[0];
                        } else {
                            event.id = traveller.journey.booking.code;
                        }
                    } else {
                        event.id = traveller.journey.id;
                        event.host = traveller.journey.host;
                    }
                    
                    if(!loadedPnrIds.includes(event.id)){
                        this.showPnr(JSON.stringify(event));
                        loadedPnrIds.push(event.id);
                    }
                }
            }
        });


        // 
    }

    public setTnrError(message?: string): void {
        this.tnrPending = false;
        this.tnrError = true;
        this.tnrErrorMessage = message ? message : this.apiLabels.error;
    }


    /**
     * focus
     *
     * used to focus on input
     */
    public focusIdInput() {
        this.focusInput.emit(true);
    }

    public blurIdInput() {
        this.focusInput.emit(false);
    }


}
